import { createContext } from 'react';
import { DataHygieneAddress } from 'types/domain';

const DataHygieneAddressContext = createContext<{ address: DataHygieneAddress }>({
    address: {} as DataHygieneAddress,
});

export { DataHygieneAddressContext };
